var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"添加回款金额","confirmLoading":_vm.loading,"destroyOnClose":true},on:{"ok":_vm.handleOk},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('a-form',{attrs:{"form":_vm.form}},[_c('a-form-item',_vm._b({attrs:{"label":"回款金额"}},'a-form-item',_vm.formItemsLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'amount',
          {
            rules: [
              { required: true, message: '请填写回款金额' },
              {
                transform(value) {
                  return +value;
                },
                type: 'number',
                message: '请填写数字'
              }
            ]
          }
        ]),expression:"[\n          'amount',\n          {\n            rules: [\n              { required: true, message: '请填写回款金额' },\n              {\n                transform(value) {\n                  return +value;\n                },\n                type: 'number',\n                message: '请填写数字'\n              }\n            ]\n          }\n        ]"}],attrs:{"addonAfter":"元"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }